/*
 * In this file, all kinds of initializations that vary from project to project are performed.
 */

import '@/scripts/utils/polyfil';

import { TweenLite, Power1 } from 'gsap/TweenMax';
import 'EasePack';
import 'ScrollToPlugin';
import objectFitImages from 'object-fit-images';
import objectFitVideos from 'object-fit-videos';
import loadFonts from '@/scripts/utils/load-fonts';
import '@/scripts/elements/preloader';
import '@/scripts/elements/cookies';
import HeaderNav from '@/scripts/elements/header-nav';
import initLanguagesSwitcher from '@/scripts/elements/language-switcher';
import initHeaderSearch from '@/scripts/elements/header-search';
import initCoverSlider from '@/scripts/blocks/cover-slider';
import '@/scripts/elements/cover';
import '@/scripts/elements/scrollToTop';
import initButtons from '@/scripts/elements/buttons';
import focusInput from '@/scripts/elements/form-input';
import initSliders from '@/scripts/blocks/sliders';
import initModals from '@/scripts/blocks/modals';
import initAccordions from '@/scripts/blocks/accordions';
import Showrooms from '@/scripts/blocks/showrooms';
import Form from '@/scripts/blocks/contact-form';

// scrollmagic scenes
import '@/scripts/utils/scrollmagic/scenes/demo-scene_default';

import '@/fonts';
import '@/styles/main.scss';

loadFonts(['Raleway:300,400,500,600:latin']);

TweenLite.defaultEase = Power1.easeOut;

document.addEventListener('DOMContentLoaded', () => {
  // set css transition-duration to get it in JS
  const duration = getComputedStyle(document.documentElement)['transition-duration'];
  document.documentElement.dataset.duration = parseFloat(duration);

  function initHeader() {
    new HeaderNav({ // eslint-disable-line no-new
      menuScrollElement: '[data-role="menu"]',
      transitionDuration: 450, // $_menu-duration in scss file.
    });
    initLanguagesSwitcher();
    initHeaderSearch();
  }

  initHeader();
  initCoverSlider();
  initButtons();
  focusInput();
  initSliders();
  initModals();
  initAccordions();

  function initShowroomSearch() {
    const showroomContainer = document.querySelector('[data-type="showrooms"]');
    if (!showroomContainer) return;
    const showroomGrid = showroomContainer.querySelector('[data-type="showroom-grid"]');
    new Showrooms({
      showroomContainer,
      showroomGrid,
    });
  }
  initShowroomSearch();

  function initContactForm() {
    const forms = document.querySelectorAll('[data-type*="form"]');
    Array.from(forms).forEach((el) => {
      new Form({ // eslint-disable-line no-new
        element: el,
        select: '[data-type*="select"]',
      });
    });
  }

  initContactForm();


  /**
   * object-fit polyfill
   */
  objectFitImages(); // https://www.npmjs.com/package/object-fit-images
  objectFitVideos(); // https://www.npmjs.com/package/object-fit-videos
});



// WEBPACK FOOTER //
// ./scripts/common.js